import React, { useMemo } from "react";
import {
  ActionComponent,
  getActionType,
  getProposedRenderField,
} from "../FindingsReview";
import { Avatar, Col, Comment, Divider, Row, Tooltip, Typography } from "antd";
import { CellRenderers } from "utils/tableUtils";
import { useFindingDetails } from "./FindingDetailsProvider";
import { flatMap, isArray, map } from "lodash";

const { Title } = Typography;

export default function FindingProposalDetails() {
  const { finding: { proposedData, ...finding } = {}, fetchFinding } =
    useFindingDetails();

  const finalProposedData = useMemo(() => getProposedDataWithCustomFields(proposedData), [proposedData]);

  const getItems = (item, i) => {
    const userName = item.userEmail || "";
    const matches = userName.match(/\b(\w)/g);
    const actionType = getActionType(item);
    const isProposeCustomFields = item.action === "PROPOSE_CUSTOM_FIELDS"

    const params = {
      record: { ...finding, ...item },
      action: "ACCEPT",
      callBack: fetchFinding,
    };
    if(isProposeCustomFields){
      const proposedValuePayload = JSON.parse(item.proposedValue)[0]
      delete proposedValuePayload.customFieldValue;
      params.customFieldPayload = proposedValuePayload 
    }
    return (
      <div key={i}>
        <Comment
          author={userName}
          avatar={
            <Avatar size="small">{matches?.join("") || userName[0]}</Avatar>
          }
          content={
            <Row>
              <Col span={20}>
                <div className="m-r-xs pull-left">{actionType.label} from</div>{" "}
                {getProposedRenderField({
                  ...finding,
                  armorcodeCategory:
                    finding.armorcodeCategory || finding.category,
                  proposedData: [item],
                })}
                <strong className="m-r-xs">Note:</strong>
                {item.requestActionNote}
              </Col>
              <Col span={4} className="text-right">
                <ActionComponent
                  {...{ params, permission: actionType.permission }}
                />
              </Col>
            </Row>
          }
          datetime={
            <Tooltip
              title={CellRenderers.TIME_RELATIVE(item.proposedOn)}
              placement="right"
            >
              {CellRenderers.TIME(item.proposedOn)}
            </Tooltip>
          }
        />
        {i !== finalProposedData.length - 1 ? <Divider className="m-y-xs" /> : null}
      </div>
    );
  };

  return (
    <>
      <Title className="m-b-0" level={5}>
        Proposed Finding In Review
      </Title>
      {map(finalProposedData, getItems)}
    </>
  );
}

       
export const getProposedDataWithCustomFields = (proposedData) => flatMap(proposedData,  (item) => {
  //All the custom fields proposal are present in proposedValue as a JSON
  //parsing and extracting each custom field proposal to be an individual action
  if (item.action === "PROPOSE_CUSTOM_FIELDS") {
    try {
      const parsed = JSON.parse(item.proposedValue);
      if (isArray(parsed)) {
        return parsed.map((field) => ({
          ...item,
          proposedValue: JSON.stringify([field])
        }));
      }
    } catch (e) {}
  }
  return item;
})